import {
	formatCurrency,
	formatCurrencyInput,
	unformatCurrencyInput
} from './currency';
import {
	formatFixedPoint,
	formatFixedPointInput,
	unformatFixedPointInput
} from './fixedPoint';

export const formatValue = ( type, value ) => {
	switch ( type ) {
		case 'currency':
			return formatCurrency( value );
		case 'fixedPoint': {
			const [ fp ] = type.split( '_' );

			return formatFixedPoint( fp, value );
		}

		default:
			throw Error( 'invalid `type` argument provided to `maskValue` function.' );
	}
};

export const formatInputValue = ( type, value ) => {
	switch ( type ) {
		case 'currency':
			return formatCurrencyInput( value );
		case 'fixedPoint': {
			const [ fp ] = type.split( '_' );

			return formatFixedPointInput( fp, value );
		}

		default:
			throw Error( 'invalid `type` argument provided to `maskValue` function.' );
	}
};

export const unformatInputValue = ( type, value ) => {
	switch ( type ) {
		case 'currency':
			return unformatCurrencyInput( value );
		case 'fixedPoint': {
			const [ fp ] = type.split( '_' );

			return unformatFixedPointInput( fp, value );
		}

		default:
			throw Error( 'invalid `type` argument provided to `maskValue` function.' );
	}
};
